import { Flex, Box } from '@chakra-ui/layout';
import {
  Table,
  Spacer,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Button,
  Select,
  useToast,
} from '@chakra-ui/react';
import { Pagination } from 'antd';
import axios from 'axios';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import CardHeader from 'components/Card/CardHeader';
import { SearchInput } from 'components/SearchInput';
import { usePagination } from 'hooks/use-pagination';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { BlogTableRow } from './BlogTableRow';
import { BlogCategoryModal } from './BlogCategoryModal';

export function BlogList() {
  const textColor = useColorModeValue('gray.700', 'white');
  const toast = useToast();
  const history = useHistory();
  const [blogs, setBlogs] = useState([]);
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState('');
  const { currentPage, total, onPageChange, setQuery } = usePagination(
    '/admin/blogs',
    setBlogs,
  );

  useEffect(() => {
    axios.get('/admin/blog-categories').then((res) => setCategories(res.data));
  }, []);

  const onUpdateRow = (updatedBlog) => {
    setBlogs((prev) =>
      prev.map((blog) => (blog.id === updatedBlog.id ? updatedBlog : blog)),
    );
  };

  const onClickSearch = (searchWord) => {
    setQuery({ search: searchWord, page: 1 });
  };

  const onCategoryChange = (e) => {
    setCategoryId(e.target.value);
    setQuery({ categoryId: e.target.value, page: 1 });
  };

  const handleAddClick = () => {
    if (categories.length === 0) {
      toast({
        title: '카테고리를 먼저 추가해주세요.',
        status: 'warning',
        isClosable: true,
      });
      return;
    }
    history.push('/admin/blogs/write');
  };

  const colNames = [
    '번호',
    '제목',
    '카테고리',
    '수정자',
    '조회수',
    '게시여부',
    '생성일',
  ];

  return (
    <Flex direction="column" pt={{ base: '120px', md: '75px' }}>
      <Card overflowX={{ sm: 'scroll', xl: 'hidden' }}>
        <CardHeader p="6px 0px 22px 0px">
          <Flex width="100%" alignItems="center" gap={4}>
            <Text fontSize="xl" color={textColor} fontWeight="bold">
              블로그 관리
            </Text>
            <Select
              w="150px"
              value={categoryId}
              onChange={onCategoryChange}
              placeholder="전체 카테고리"
            >
              {categories.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
            </Select>
            <SearchInput setSearch={onClickSearch} />
            <Text fontWeight="bold">총 {total}개</Text>
            <Spacer />
            <BlogCategoryModal
              categories={categories}
              setCategories={setCategories}
            />
            <Button colorScheme="green" onClick={handleAddClick}>
              등록
            </Button>
          </Flex>
        </CardHeader>
        <CardBody>
          <Table variant="simple" color={textColor}>
            <Thead>
              <Tr my=".8rem" pl="0px" color="gray.400">
                {colNames.map((colName, idx) => (
                  <Th color="gray.400" key={idx} ps={idx === 0 ? '0px' : null}>
                    {colName}
                  </Th>
                ))}
              </Tr>
            </Thead>
            <Tbody>
              {blogs.map((row, index) => (
                <BlogTableRow
                  key={row.id}
                  blog={row}
                  total={total}
                  page={currentPage}
                  index={index}
                  onUpdateRow={onUpdateRow}
                />
              ))}
            </Tbody>
          </Table>
        </CardBody>
        <Box mt="5">
          <Pagination
            showSizeChanger={false}
            current={currentPage}
            onChange={onPageChange}
            total={total}
          />
        </Box>
      </Card>
    </Flex>
  );
}
